import { combineReducers, configureStore, Action } from '@reduxjs/toolkit';
import { ThunkAction } from 'redux-thunk';


import nft, {actions as nftActions} from './services/nft';
import mint from './services/mint';

const rootReducer = combineReducers({
  nft,
  mint,
});

export type RootState = ReturnType<typeof rootReducer>;

export type AppThunk<T = void> = ThunkAction<T, RootState, null, Action<string>>;

const store = configureStore({
  reducer: rootReducer
});

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./store', () => {
    store.replaceReducer(rootReducer);
  });
}

if (typeof window !== 'undefined') {
  store.dispatch(nftActions.loadStats() as any);
}

export type AppDispatch = typeof store.dispatch;
export default store; 